import { FormattedMessage } from 'react-intl';

import { PORTABLE_CALL_NUMBER } from '@/utils/constants';

const CallUs = () => {
  const rcNumber = PORTABLE_CALL_NUMBER;

  return (
    <>
      <a
        className="text-white text-decoration-none"
        href={`tel:${rcNumber}` || ''}
      >
        <button className="btn as-primary-btn">
          <FormattedMessage id="call" />: {rcNumber}
        </button>
      </a>
    </>
  );
};

export default CallUs;
